<template>
  <div v-loading="loading" class="org-users shared-index">
    <h3 class="m-0">Phân quyền Menus</h3>

    <!-- Header Tabs & Controls -->
    <el-row class="table-title mb-3" type="flex" align="middle" justify="space-between">
      <div class="table-title__left">
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane name="menus">
            <div slot="label">
              Danh sách Menus
              <span>({{ totalMenus }})</span>
            </div>
          </el-tab-pane>
          <el-tab-pane name="permissions">
            <div slot="label">
              Phân quyền Resources
              <span>({{ displayResources.length }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>

        <el-button
          v-if="activeTab === 'menus'"
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          class="ml-2"
          @click="visible = true"
        >
          Thêm menu mới
        </el-button>
      </div>

      <div class="table-title__right">
        <template v-if="activeTab === 'permissions'">
          <el-button
            size="small"
            type="text"
            class="mr-2"
            @click="handleToggleExpandAll"
          >
            {{ allExpanded ? 'Thu gọn tất cả' : 'Mở tất cả' }}
          </el-button>
          <el-input
            v-model="searchResource"
            prefix-icon="el-icon-search"
            placeholder="Tìm kiếm resource..."
            size="small"
            clearable
            style="width: 260px"
          />
        </template>
      </div>
    </el-row>

    <!-- Main Content -->
    <div v-if="!loading" class="table">
      <!-- TAB 1: Danh sách Menus được thêm -->
      <div v-if="activeTab === 'menus'">
        <div v-if="!totalMenus" class="empty-state p-4 text-center text-muted">
          Tổ chức chưa có menus nào. Nhấn "Thêm menu mới" để thêm menu.
        </div>
        <el-table
          v-else
          :data="allOrgMenus"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column type="index" label="STT" width="60" align="center" />
          <el-table-column label="Tên Menu" min-width="180">
            <template slot-scope="{ row }">
              <i :class="[row.icon || 'el-icon-menu', 'mr-2 text-primary']" />
              <b>{{ row.title }}</b>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="Mã Menu" width="180">
            <template slot-scope="{ row }">
              <el-tag size="small">{{ row.type }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="API Endpoints" min-width="260">
            <template slot-scope="{ row }">
              <span v-if="row.apiEndpoints && row.apiEndpoints.length">
                <el-tag
                  v-for="(ep, i) in row.apiEndpoints.slice(0, 3)"
                  :key="i"
                  size="mini"
                  type="info"
                  class="mr-1 mb-1"
                >
                  {{ ep }}
                </el-tag>
                <el-tag v-if="row.apiEndpoints.length > 3" size="mini" type="info">
                  +{{ row.apiEndpoints.length - 3 }} khác
                </el-tag>
              </span>
              <span v-else class="text-muted">Không có</span>
            </template>
          </el-table-column>
          <el-table-column label="Thao tác" width="120" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="() => handleDeleteOrganizationMenu(row)"
              >
                Xóa
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- TAB 2: Phân quyền (List collapse cards) -->
      <div v-else-if="activeTab === 'permissions'">
        <div v-if="!displayResources.length" class="empty-state p-4 text-center text-muted">
          {{ searchResource ? 'Không tìm thấy resource phù hợp' : 'Không có resource nào được ánh xạ từ danh sách menus' }}
        </div>
        <el-collapse
          v-else
          v-model="activeCollapseNames"
          class="resource-collapse-cards"
        >
          <el-collapse-item
            v-for="res in displayResources"
            :key="res.key"
            :name="res.key"
            class="resource-card-item"
          >
            <template slot="title">
              <div class="resource-header w-100 pr-3">
                <div class="resource-title-wrap">
                  <i class="el-icon-folder-opened mr-2 text-primary" />
                  <b class="resource-name">{{ res.name }}</b>
                  <el-tag size="mini" type="info" class="ml-2">{{ res.endpoint }}</el-tag>
                  <el-tag
                    v-if="res.resource_type && res.resource_type !== 'API'"
                    size="mini"
                    type="success"
                    class="ml-1"
                  >
                    {{ res.resource_type }}
                  </el-tag>
                  <el-tag
                    v-if="res.required"
                    size="mini"
                    type="warning"
                    class="ml-1"
                  >
                    Bắt buộc
                  </el-tag>
                </div>
                <div class="resource-meta-wrap">
                  <el-tag
                    size="mini"
                    :type="res.enabledCount > 0 ? 'success' : 'info'"
                  >
                    {{ res.enabledCount }}/{{ res.actions.length }} quyền bật
                  </el-tag>
                </div>
              </div>
            </template>

            <!-- Danh sách actions của resource -->
            <div class="resource-actions-wrap">
              <el-table
                :data="res.actions"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column label="Hành động" width="220">
                  <template slot-scope="{ row }">
                    <el-tag :type="getActionTagType(row.key)" size="small" effect="dark" class="mr-2">
                      {{ row.key }}
                    </el-tag>
                    <span>{{ row.label || row.name || row.key }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="Trạng thái" width="160" align="center">
                  <template slot-scope="{ row }">
                    <el-switch
                      :value="row.is_enabled"
                      active-text="Bật"
                      inactive-text="Tắt"
                      :disabled="!row.id || res.required"
                      @change="(val) => handleToggleAction(row, val)"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="Danh sách tài khoản phân quyền (Whitelist)" min-width="320">
                  <template slot-scope="{ row }">
                    <div class="whitelist-cell">
                      <!-- Khi is_enabled = true -> Mặc định áp dụng cho tất cả tài khoản thành viên -->
                      <div v-if="row.is_enabled || res.required" class="text-success font-size-12">
                        <i class="el-icon-circle-check mr-1" />
                        Mặc định áp dụng cho tất cả tài khoản thành viên
                      </div>

                      <!-- Khi is_enabled = false -> Hiện box whitelist tương ứng -->
                      <div v-else class="whitelist-box">
                        <div class="assignee-tags mb-2">
                          <span
                            v-if="!row.organization_action_assignees || row.organization_action_assignees.length === 0"
                            class="text-muted font-size-12 mr-2"
                          >
                            Chưa có tài khoản nào được phân quyền trong Whitelist
                          </span>
                          <el-tag
                            v-for="(assign, idx) in (row.organization_action_assignees || [])"
                            :key="idx"
                            size="small"
                            type="info"
                            class="mr-1 mb-1"
                          >
                            <i class="el-icon-user mr-1" />
                            {{ getUserDisplayName(assign) }}
                          </el-tag>
                        </div>

                        <!-- Quick Add Assignee vào Whitelist -->
                        <div class="quick-add-user">
                          <el-select
                            v-model="userSelectMap[row.id]"
                            size="mini"
                            filterable
                            placeholder="Chọn tài khoản vào Whitelist"
                            style="width: 220px"
                          >
                            <el-option
                              v-for="user in getAvailableUsers(row)"
                              :key="user.id"
                              :label="user.name || user.email"
                              :value="user.id"
                            >
                              <span style="float: left">{{ user.name || user.email }}</span>
                              <span v-if="user.name && user.email" style="float: right; color: #8492a6; font-size: 12px">
                                {{ user.email }}
                              </span>
                            </el-option>
                          </el-select>
                          <el-button
                            type="primary"
                            size="mini"
                            class="ml-2"
                            :disabled="!userSelectMap[row.id]"
                            @click="() => handleAssignUser(row)"
                          >
                            Thêm
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!-- Popup thêm menu -->
    <add-menu-popup
      v-if="visible"
      :visible="visible"
      :org-menus="oldOrgMenus"
      :menus="menus"
      :actions="actions"
      :organization="organization"
      @reload="handleReload"
      @close="visible = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getOrganizationActions,
  deleteOrganizationAction,
  createOrganizationAction,
  updateOrganizationAction,
  createOrganizationActionAssign
} from '@/services/organization-action'
import { getActions, getManagedResources } from '@/services/public'
import { orgContents } from '@/utils/filters'
import { updateOrganization } from '@/services/organizations'
import { loginInfo, updateLoginInfo } from '@/services/auth'
import ROUTER from '@/data/router'
import CONSTANTS from '@/config/constants'
import { RESOURCES } from '@/data/resource'
import AddMenuPopup from './popups/AddMenu.vue'

export default {
  name: 'OrgMenus',
  components: {
    AddMenuPopup
  },
  props: {
    organization: Object
  },
  data() {
    return {
      loading: true,
      visible: false,
      activeTab: 'menus',
      searchResource: '',
      activeCollapseNames: [],
      actions: [],
      orgActions: [],
      allManagedResources: [],
      menus: ROUTER.MENUS,
      userSelectMap: {}
    }
  },
  computed: {
    ...mapGetters(['language']),
    oldOrgMenus() {
      return (this.organization && this.organization.menus ? this.organization.menus.split(',') : [])
        .map((m) => m.trim())
        .filter(Boolean)
    },
    allOrgMenus() {
      return this.oldOrgMenus
        .map((m) => this.menus.find((p) => p.type === m))
        .filter(Boolean)
    },
    totalMenus() {
      return this.allOrgMenus.length
    },
    // 1. Lấy toàn bộ apiEndpoints của menus (lọc trùng nhau)
    orgApiEndpoints() {
      const endpoints = this.allOrgMenus.flatMap((m) => m.apiEndpoints || [])
      return [...new Set(endpoints.filter(Boolean))]
    },
    // 2. Filter list RESOURCES theo apiEndpoints bước 1
    filteredResources() {
      const orgMenuTypes = new Set(this.allOrgMenus.map((m) => m.type))
      return RESOURCES.filter((res) => {
        if (!res || !res.endpoint) return false
        if (!this.orgApiEndpoints.includes(res.endpoint)) return false

        // Đối với place-type resources (resource_type !== 'API')
        if (res.resource_type && res.resource_type !== 'API') {
          return orgMenuTypes.has(res.resource_type)
        }
        return true
      })
    },
    displayResources() {
      let list = this.filteredResources.map((res) => {
        const backendRes = this.findBackendResource(res)
        const backendResourceId = backendRes ? backendRes.id : null
        const resOrgActions = backendResourceId
          ? this.orgActions.filter((oa) => {
            const rId = String(oa.resource_id || (oa.resource && oa.resource.id))
            return rId === String(backendResourceId)
          })
          : []

        const actions = (res.actions || []).map((actKey) => {
          const actDef = this.findActionDef(actKey) || {}
          const orgAct = resOrgActions.find((oa) => {
            const aId = String(oa.action_id || (oa.action && oa.action.id))
            return actDef.id && aId === String(actDef.id)
          })

          return {
            key: actKey,
            label: actDef.label || actKey,
            id: orgAct ? orgAct.id : null,
            action_id: actDef.id || null,
            resource_id: backendResourceId,
            is_enabled: orgAct ? Boolean(orgAct.is_enabled) : false,
            organization_action_assignees: orgAct ? (orgAct.organization_action_assignees || []) : []
          }
        })

        const actionOrder = { GET: 1, CREATE: 2, UPDATE: 3, DELETE: 4 }
        actions.sort((a, b) => (actionOrder[a.key] || 99) - (actionOrder[b.key] || 99))

        const enabledCount = actions.filter((a) => a.is_enabled).length

        return {
          key: `${res.endpoint}_${res.resource_type || 'API'}`,
          name: res.name || (backendRes && backendRes.name) || res.endpoint,
          endpoint: res.endpoint,
          resource_type: res.resource_type,
          required: Boolean(res.required),
          backendResourceId,
          actions,
          enabledCount
        }
      })

      // Sắp xếp danh sách resource: Ưu tiên bắt buộc (required) lên đầu, sau đó theo thứ tự bảng chữ cái A-Z
      list.sort((a, b) => {
        if (a.required !== b.required) {
          return b.required ? 1 : -1
        }
        const nameA = a.name || a.endpoint || ''
        const nameB = b.name || b.endpoint || ''
        const comp = nameA.localeCompare(nameB, 'vi', { sensitivity: 'base' })
        if (comp !== 0) return comp
        return (a.endpoint || '').localeCompare(b.endpoint || '')
      })

      if (this.searchResource) {
        const kw = this.searchResource.trim().toLowerCase()
        list = list.filter(
          (r) =>
            (r.name && r.name.toLowerCase().includes(kw)) ||
            (r.endpoint && r.endpoint.toLowerCase().includes(kw)) ||
            (r.resource_type && r.resource_type.toLowerCase().includes(kw))
        )
      }

      return list
    },
    allExpanded() {
      return this.displayResources.length > 0 && this.activeCollapseNames.length === this.displayResources.length
    }
  },
  watch: {
    'organization.menus': 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        await Promise.all([
          this.handleGetActions(),
          this.handleGetManagedResources()
        ])
        await this.handleFetchAndSyncOrgActions()
      } catch (err) {
        console.error('Error loading org menus data:', err)
      } finally {
        this.loading = false
      }
    },

    async handleGetActions() {
      await getActions({})
        .then((response) => {
          this.actions = (response.result || []).map((action) => {
            const ac = CONSTANTS.ACTIONS.find((a) => a.key === action.action_type)
            return {
              ...action,
              ...(ac || { key: action.action_type, label: action.action_type })
            }
          })
        })
        .catch(() => {
          this.actions = []
        })
    },

    findBackendResource(res) {
      if (!res || !res.endpoint) return null
      const clean = (ep) => (ep || '').trim().toLowerCase().replace(/[-_]/g, '_').replace(/\/+$/, '')
      const isEndpointMatch = (ep1, ep2) => {
        if (!ep1 || !ep2) return false
        const c1 = clean(ep1)
        const c2 = clean(ep2)
        if (c1 === c2) return true
        if (c1.replace(/s$/, '') === c2.replace(/s$/, '')) return true
        return false
      }

      // 1. Nếu res yêu cầu resource_type cụ thể (khác API) - ví dụ endpoint '/place' theo từng type: 'country', 'area', ...
      if (res.resource_type && res.resource_type !== 'API') {
        const typeRes = String(res.resource_type).trim().toLowerCase()
        const exactMatch = this.allManagedResources.find((mr) => {
          if (!mr) return false
          const typeMr = String(mr.resource_type || '').trim().toLowerCase()
          return typeMr === typeRes && isEndpointMatch(mr.endpoint, res.endpoint)
        })
        if (exactMatch) return exactMatch

        // Fallback: nếu backend không lưu resource_type (chỉ có endpoint chung API)
        // và endpoint không phải là '/place' (chỉ riêng '/place' mới bắt buộc tách theo 54 resource_type)
        if (clean(res.endpoint) !== '/place') {
          const fallbackMatch = this.allManagedResources.find((mr) => {
            if (!mr) return false
            const isMatchEp = isEndpointMatch(mr.endpoint, res.endpoint)
            const isGeneral = !mr.resource_type || mr.resource_type === 'API'
            return isMatchEp && isGeneral
          })
          if (fallbackMatch) return fallbackMatch
        }
        return null
      }

      // 2. Đối với API resource hoặc resource chung (không phân theo resource_type)
      return this.allManagedResources.find((mr) => {
        if (!mr) return false
        if (!isEndpointMatch(mr.endpoint, res.endpoint)) return false

        // Không match nhầm với place resource chuyên biệt có resource_type riêng (như /place)
        if (mr.resource_type && mr.resource_type !== 'API' && mr.resource_type !== res.resource_type) {
          return false
        }
        return true
      }) || null
    },

    findActionDef(actKey) {
      if (!actKey) return null
      const keyNorm = String(actKey).trim().toUpperCase()
      return this.actions.find((a) => {
        const ak = String(a.key || a.action_type || '').trim().toUpperCase()
        return ak === keyNorm
      }) || null
    },

    async handleGetManagedResources() {
      const perPage = 100
      let page = 1
      let allResources = []
      let hasMore = true
      try {
        while (hasMore) {
          const res = await getManagedResources({ page, per_page: perPage })
          const items = (res && (res.result || res.data)) || []
          if (!Array.isArray(items) || items.length === 0) {
            hasMore = false
            break
          }
          allResources = allResources.concat(items)

          const total = res.total || (res.pagination && res.pagination.total)
          if ((total && allResources.length >= total) || items.length < perPage) {
            hasMore = false
            break
          }
          page++
        }
        this.allManagedResources = allResources
      } catch (e) {
        console.error('Error fetching managed resources:', e)
        this.allManagedResources = allResources
      }
    },

    // 0. Vẫn get toàn bộ org actions đầu tiên
    async fetchAllOrgActions(organizationId) {
      const perPage = 100
      let page = 1
      let allActions = []
      let hasMore = true
      try {
        while (hasMore) {
          const res = await getOrganizationActions({ page, per_page: perPage, organization_id: organizationId })
          const items = (res && (res.result || res.data)) || []
          if (!Array.isArray(items) || items.length === 0) {
            hasMore = false
            break
          }
          allActions = allActions.concat(items)

          const total = res.total || (res.pagination && res.pagination.total)
          if ((total && allActions.length >= total) || items.length < perPage) {
            hasMore = false
            break
          }
          page++
        }
      } catch (e) {
        console.error('Error fetching all organization actions:', e)
      }
      return allActions
    },

    // 2. Filter list RESOURCES (actions) theo apiEndpoints bước 1 -> map cùng resource actions
    // check xem có thiếu org actions nào k -> tự động khởi tạo (resource có required = true thì mặc định is_enabled = true), actions nào đã tồn tại mà k nằm trong list map đó thì tự xóa
    async handleFetchAndSyncOrgActions(customMenus = null) {
      if (!this.organization || !this.organization.id) return

      const fetchedActions = await this.fetchAllOrgActions(this.organization.id)

      const activeMenus = customMenus || this.allOrgMenus
      // 1. Lấy toàn bộ apiEndpoints của menus (lọc trùng nhau)
      const activeEndpoints = [...new Set(activeMenus.flatMap((m) => m.apiEndpoints || []).filter(Boolean))]
      const activeMenuTypes = new Set([
        ...activeMenus.map((m) => m.type),
        ...this.oldOrgMenus
      ])

      // 2. Filter list RESOURCES theo apiEndpoints
      const targetResources = RESOURCES.filter((res) => {
        if (!res || !res.endpoint) return false
        if (!activeEndpoints.includes(res.endpoint)) return false
        if (res.resource_type && res.resource_type !== 'API') {
          return activeMenuTypes.has(res.resource_type)
        }
        return true
      })

      // Map cùng resource actions (sử dụng Map để loại bỏ hoàn toàn trùng lặp target pair)
      const uniqueTargetPairsMap = new Map()
      targetResources.forEach((res) => {
        const backendRes = this.findBackendResource(res)
        if (backendRes && backendRes.id) {
          (res.actions || []).forEach((actKey) => {
            const actDef = this.findActionDef(actKey)
            if (actDef && actDef.id) {
              const pairKey = `${backendRes.id}_${actDef.id}`
              if (!uniqueTargetPairsMap.has(pairKey)) {
                uniqueTargetPairsMap.set(pairKey, {
                  resource_id: String(backendRes.id),
                  action_id: String(actDef.id),
                  required: Boolean(res.required)
                })
              } else if (res.required) {
                uniqueTargetPairsMap.get(pairKey).required = true
              }
            }
          })
        }
      })

      const targetPairs = Array.from(uniqueTargetPairsMap.values())
      const validKeySet = new Set(targetPairs.map((p) => `${p.resource_id}_${p.action_id}`))
      const createRequests = []
      const deleteRequests = []

      // Check thiếu -> tự động khởi tạo, check trùng lặp -> giữ 1
      targetPairs.forEach((pair) => {
        const matching = fetchedActions.filter((a) => {
          const rId = String(a.resource_id || (a.resource && a.resource.id))
          const aId = String(a.action_id || (a.action && a.action.id))
          return rId === pair.resource_id && aId === pair.action_id
        })

        if (matching.length === 0) {
          createRequests.push(
            createOrganizationAction({
              action_id: pair.action_id,
              resource_id: pair.resource_id,
              organization_id: this.organization.id,
              is_enabled: Boolean(pair.required)
            })
          )
        } else if (matching.length > 1) {
          matching.sort((a, b) => Number(b.id) - Number(a.id))
          matching.slice(1).forEach((dup) => {
            deleteRequests.push(deleteOrganizationAction(dup.id))
          })
        }
      })

      // Actions nào đã tồn tại mà k nằm trong list map đó thì tự xóa
      fetchedActions.forEach((existingAct) => {
        const rId = String(existingAct.resource_id || (existingAct.resource && existingAct.resource.id))
        const aId = String(existingAct.action_id || (existingAct.action && existingAct.action.id))
        const key = `${rId}_${aId}`
        if (!validKeySet.has(key)) {
          deleteRequests.push(deleteOrganizationAction(existingAct.id))
        }
      })

      // Thực thi requests theo batch chunks (10 concurrent) để bảo đảm không bị rớt connection hay quá tải server
      if (createRequests.length > 0 || deleteRequests.length > 0) {
        const allReqs = [...createRequests, ...deleteRequests]
        const chunkSize = 10
        for (let i = 0; i < allReqs.length; i += chunkSize) {
          await Promise.allSettled(allReqs.slice(i, i + chunkSize))
        }
        this.orgActions = await this.fetchAllOrgActions(this.organization.id)
      } else {
        this.orgActions = fetchedActions
      }
    },

    // 4. Xóa menu cũng như vậy
    async handleDeleteOrganizationMenu(menu) {
      if (!menu) return
      this.$confirm(`Bạn có chắc chắn muốn xóa menu "${menu.title}" không?`, 'Xác nhận xóa', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(async () => {
        this.loading = true
        try {
          const remainingMenus = this.allOrgMenus.filter((m) => m.type !== menu.type)
          const remainingPlaceIds = orgContents('places', this.organization)
            .filter((p) => p && (p.place_type || p.type) !== menu.type)
            .map((p) => (p.id !== undefined ? p.id : p))

          const newMenusStr = remainingMenus.map((m) => m.type).join(',')
          await updateOrganization({
            id: this.organization.id,
            menus: newMenusStr,
            place_ids: remainingPlaceIds
          })

          if (this.organization) {
            this.$set(this.organization, 'menus', newMenusStr)
          }

          const currentLogin = loginInfo()
          if (currentLogin && currentLogin.auth_user && currentLogin.auth_user.organizations) {
            const userOrg = currentLogin.auth_user.organizations.find((o) => o.id === this.organization.id)
            if (userOrg) {
              userOrg.menus = newMenusStr
              updateLoginInfo(currentLogin)
            }
          }

          // Đồng bộ lại actions theo các menu còn lại
          await this.handleFetchAndSyncOrgActions(remainingMenus)

          this.$emit('reload')
          this.$notify.success({
            title: 'Thông báo',
            message: `Xóa menu "${menu.title}" thành công.`
          })
        } catch (error) {
          console.error('Error deleting organization menu:', error)
          this.$notify.error({
            title: 'Thông báo',
            message: 'Không thể xóa menu này!'
          })
        } finally {
          this.loading = false
        }
      }).catch(() => {})
    },

    // 3. Thêm mới 1 menu -> đồng bộ lại logic bước 2
    async handleReload() {
      this.$emit('reload')
      await this.loadData()
    },

    async handleToggleAction(actionRow, newValue) {
      if (!actionRow || !actionRow.id) return
      try {
        await updateOrganizationAction({ id: actionRow.id, is_enabled: newValue })
        actionRow.is_enabled = newValue
        const target = this.orgActions.find((a) => a.id === actionRow.id)
        if (target) {
          target.is_enabled = newValue
        }
        this.$notify.success({
          title: 'Thông báo',
          message: 'Cập nhật trạng thái quyền thành công.'
        })
      } catch (e) {
        this.$notify.error({
          title: 'Lỗi',
          message: 'Không thể cập nhật trạng thái quyền!'
        })
      }
    },

    async handleAssignUser(actionRow) {
      const userId = this.userSelectMap[actionRow.id]
      if (!actionRow || !actionRow.id || !userId) return
      try {
        const res = await createOrganizationActionAssign({
          organization_action_id: actionRow.id,
          user_id: userId
        })
        const assignedUser = (this.organization && this.organization.users ? this.organization.users : []).find(
          (u) => u.id === userId
        )
        const newAssignee = {
          id: res && res.result ? res.result.id : Date.now(),
          organization_action_id: actionRow.id,
          user_id: userId,
          user: assignedUser || { id: userId, email: '' }
        }
        if (!actionRow.organization_action_assignees) {
          this.$set(actionRow, 'organization_action_assignees', [])
        }
        actionRow.organization_action_assignees.push(newAssignee)

        const target = this.orgActions.find((a) => a.id === actionRow.id)
        if (target) {
          if (!target.organization_action_assignees) {
            this.$set(target, 'organization_action_assignees', [])
          }
          target.organization_action_assignees.push(newAssignee)
        }

        this.$set(this.userSelectMap, actionRow.id, null)
        this.$notify.success({
          title: 'Thông báo',
          message: 'Thêm tài khoản vào danh sách phân quyền thành công.'
        })
      } catch (e) {
        this.$notify.error({
          title: 'Thông báo',
          message: 'Không thể thêm tài khoản!'
        })
      }
    },

    getActionTagType(key) {
      switch (key) {
        case 'GET': return 'success'
        case 'CREATE': return 'primary'
        case 'UPDATE': return 'warning'
        case 'DELETE': return 'danger'
        default: return 'info'
      }
    },

    getUserDisplayName(assign) {
      if (!assign) return ''
      if (assign.user) {
        return assign.user.name || assign.user.email || `User #${assign.user_id}`
      }
      return `User #${assign.user_id}`
    },

    getAvailableUsers(actionRow) {
      const orgUsers = (this.organization && this.organization.users) || []
      const assignedIds = (actionRow.organization_action_assignees || []).map((a) => a.user_id)
      return orgUsers.filter((u) => !assignedIds.includes(u.id))
    },

    handleToggleExpandAll() {
      if (this.allExpanded) {
        this.activeCollapseNames = []
      } else {
        this.activeCollapseNames = this.displayResources.map((r) => r.key)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  font-size: 14px;
}

.resource-collapse-cards {
  border: none;

  ::v-deep .el-collapse-item {
    margin-bottom: 12px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    }

    .el-collapse-item__header {
      padding: 0 16px;
      height: 52px;
      line-height: 52px;
      background-color: #fafbfc;
      border-bottom: 1px solid transparent;
      font-size: 14px;

      &.is-active {
        border-bottom-color: #ebeef5;
        background-color: #f5f7fa;
      }
    }

    .el-collapse-item__wrap {
      border-bottom: none;
    }

    .el-collapse-item__content {
      padding: 16px;
    }
  }
}

.resource-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .resource-title-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}

.whitelist-cell {
  .assignee-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .quick-add-user {
    display: flex;
    align-items: center;
  }
}

.font-size-12 {
  font-size: 12px;
}
</style>
